// src/kyc/sections/view/KycViewCustomerDetails.jsx
import React from "react";
// import { Tile, Block, InfoItem } from "./ViewUI";

import iconName from "../../../images/avatar.svg";
import iconPassport from "../../../images/passport.svg";
import iconDateOfBirth from "../../../images/birthday.svg";
import iconAddress from "../../../images/address.svg";
// import iconBusinessActivity from "../../../images/briefcase.svg";
import iconBusinessActivity from "../../../images/briefcaseX.svg";
import iconEmail from "../../../images/email_icon.svg";
import iconPhoneCall from "../../../images/phone-call.svg";
import iconWebsite from "../../../images/internet.svg";

import Lottie from "lottie-react";
import iconNameJson from "../../../images/individual-lottie.json";
import iconEntityNameJson from "../../../images/building-lottie.json";

function fmtDate(v) {
  if (!v) return "";
  try {
    const d = typeof v?.toDate === "function" ? v.toDate() : new Date(v);
    if (Number.isNaN(d.getTime())) return "";
    return new Intl.DateTimeFormat("en-GB", {
      // day: "2-digit",
      day: "numeric",
      month: "short",
      year: "numeric",
    }).format(d);
  } catch {
    return "";
  }
}

function countryCodeToName(code) {
  const c = String(code || "")
    .trim()
    .toUpperCase();
  if (!c) return "";

  try {
    const dn = new Intl.DisplayNames(["en"], { type: "region" });
    return dn.of(c) || c;
  } catch {
    return c;
  }
}

function splitAddressParts(customer) {
  const countryCode = String(customer.country || "")
    .trim()
    .toUpperCase();
  const countryName = countryCodeToName(countryCode);

  return {
    street: customer.address || "",
    city: customer.city || "",
    countryCode,
    countryName,
  };
}

export default function KycViewCustomerDetails({
  sectionNo = 0,
  form,
  useMainCountryOfOperation = false,
}) {
  const customer = form?.customer || {};
  const isEntity = customer.type === "entity";
  const hasMainCountryOfOperation =
    isEntity &&
    useMainCountryOfOperation &&
    String(customer.mainCountryOfOperation || "").trim();
  const { street, city, countryCode, countryName } =
    splitAddressParts(customer);

  return (
    <div className="card kycCard">
      {/* ✅ always beige band */}
      <div className="kycSectionHead">
        <h5 className="kycSectionTitle">
          {sectionNo ? `${sectionNo} | ` : ""}Customer identification
        </h5>
      </div>

      <div className="kycSectionBody">
        <div className="row g-3">
          <div className="col-12">
            <div
              className="kycViewTile kycViewIdentityCard"
              style={{ background: "#F6F4F2" }}
            >
              <div className="row g-3">
                {/* NAME */}
                <div className="col-12 col-lg-6">
                  <div className="kycInfoItem">
                    {/* <div className="kycInfoIcon">
                      <img
                        src={isEntity ? iconName : iconName}
                        alt=""
                        className="kycInfoIconImg"
                      />
                    </div> */}

                    <div
                      className="kycInfoIcon"
                      style={{ background: "transparent" }}
                    >
                      <Lottie
                        animationData={
                          isEntity ? iconEntityNameJson : iconNameJson
                        }
                        loop
                        autoplay
                      />
                    </div>

                    <div className="kycInfoContent">
                      <div className="kycInfoViewLabel">
                        {isEntity ? "Entity name" : "Full name"}
                      </div>
                      {/* kycInfoViewText */}
                      <div
                        className=""
                        style={{ fontSize: 24, fontWeight: 300 }}
                      >
                        {customer.name || "—"}
                      </div>
                    </div>
                  </div>
                </div>
                {/* NATIONALITY */}
                {/* <div className="col-3">
                  <div className="kycInfoItem">
                    <div className="kycInfoIcon">
                      <img
                        src={iconPassport}
                        alt=""
                        className="kycInfoIconImg"
                      />
                    </div>

                    <div className="kycInfoContent">
                      <div className="kycInfoViewLabel">
                        {isEntity ? "Incorporation country" : "Nationality"}
                      </div>

                      {customer.nationalityOrIncorporationCountry ? (
                        <div className="kycInfoViewText kycViewCountryValue">
                          <img
                            src={`https://flagcdn.com/w40/${String(
                              customer.nationalityOrIncorporationCountry
                            ).toLowerCase()}.png`}
                            alt=""
                            className="kycRoundFlag"
                          />
                          <span>
                            {countryCodeToName(
                              customer.nationalityOrIncorporationCountry
                            )}
                          </span>
                        </div>
                      ) : (
                        <div className="kycInfoViewText kycViewMuted">—</div>
                      )}
                    </div>
                  </div>
                </div> */}
                {/* --- */}

                {/* DATE OF BIRTH */}
                {/* <div className="col-3">
                  <div className="kycInfoItem">
                    <div className="kycInfoIcon">
                      <img
                        src={iconDateOfBirth}
                        alt=""
                        className="kycInfoIconImg"
                      />
                    </div>

                    <div className="kycInfoContent">
                      <div className="kycInfoViewLabel">
                        {isEntity ? "Date of incorporation" : "Date of birth"}
                      </div>
                      <div className="kycInfoViewText">
                        {fmtDate(customer.dobOrIncorporationDate) || "—"}
                      </div>
                    </div>
                  </div>
                </div> */}
                {/* --- */}
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="kycViewTile kycViewIdentityCard">
              <div className="row g-3">
                <div className={hasMainCountryOfOperation ? "col-3" : "col-6"}>
                  {/* ADDRESS */}
                  <div className="kycInfoItem">
                    <div className="kycInfoIcon">
                      <img
                        src={iconAddress}
                        alt=""
                        className="kycInfoIconImg"
                      />
                    </div>

                    <div className="kycInfoContent">
                      <div className="kycInfoViewLabel">
                        {isEntity ? "Registered address" : "Address"}
                      </div>

                      {street || city || countryName ? (
                        <div className="kycInfoViewText kycAddressLine">
                          <img
                            src={`https://flagcdn.com/w40/${countryCode.toLowerCase()}.png`}
                            alt=""
                            className="kycRoundFlag"
                            style={{ marginRight: 10, marginBottom: 3 }}
                          />
                          <span>
                            {[street, city].filter(Boolean).join(", ")}
                            {[street, city].filter(Boolean).length &&
                            countryName
                              ? ", "
                              : ""}
                          </span>

                          {countryName ? (
                            <span className="kycCountryInline">
                              <span>{countryName}</span>
                            </span>
                          ) : null}
                        </div>
                      ) : (
                        <div className="kycInfoViewText">—</div>
                      )}
                    </div>
                  </div>
                </div>
                {/* NATIONALITY */}
                <div className="col-3">
                  <div className="kycInfoItem">
                    <div className="kycInfoIcon">
                      <img
                        src={iconPassport}
                        alt=""
                        className="kycInfoIconImg"
                      />
                    </div>

                    <div className="kycInfoContent">
                      <div className="kycInfoViewLabel">
                        {isEntity ? "Incorporation country" : "Nationality"}
                      </div>

                      {customer.nationalityOrIncorporationCountry ? (
                        <div className="kycInfoViewText kycViewCountryValue">
                          <img
                            src={`https://flagcdn.com/w40/${String(
                              customer.nationalityOrIncorporationCountry
                            ).toLowerCase()}.png`}
                            alt=""
                            className="kycRoundFlag"
                          />
                          <span>
                            {countryCodeToName(
                              customer.nationalityOrIncorporationCountry
                            )}
                          </span>
                        </div>
                      ) : (
                        <div className="kycInfoViewText kycViewMuted">—</div>
                      )}
                    </div>
                  </div>
                </div>

                {hasMainCountryOfOperation ? (
                  <div className="col-3">
                    <div className="kycInfoItem">
                      <div className="kycInfoIcon">
                        <img
                          src={iconPassport}
                          alt=""
                          className="kycInfoIconImg"
                        />
                      </div>

                      <div className="kycInfoContent">
                        <div className="kycInfoViewLabel">
                          Main country of operation
                        </div>

                        <div className="kycInfoViewText kycViewCountryValue">
                          <img
                            src={`https://flagcdn.com/w40/${String(
                              customer.mainCountryOfOperation
                            ).toLowerCase()}.png`}
                            alt=""
                            className="kycRoundFlag"
                          />
                          <span>
                            {countryCodeToName(customer.mainCountryOfOperation)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}

                {/* DATE OF BIRTH */}
                <div className="col-3">
                  <div className="kycInfoItem">
                    <div className="kycInfoIcon">
                      <img
                        src={iconDateOfBirth}
                        alt=""
                        className="kycInfoIconImg"
                      />
                    </div>

                    <div className="kycInfoContent">
                      <div className="kycInfoViewLabel">
                        {isEntity ? "Date of incorporation" : "Date of birth"}
                      </div>
                      <div className="kycInfoViewText">
                        {fmtDate(customer.dobOrIncorporationDate) || "—"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* </div> */}
            </div>
          </div>

          <div className="col-12" style={{ display: "none" }}>
            <div className="kycViewTile">
              {/* ADDRESS */}
              {/* <div className="kycInfoItem">
                <div className="kycInfoIcon">
                  <img src={iconAddress} alt="" className="kycInfoIconImg" />
                </div>

                <div className="kycInfoContent">
                  <div className="kycInfoViewLabel">
                    {isEntity ? "Registered address" : "Address"}
                  </div>

                  {street || city || countryName ? (
                    <div className="kycInfoViewText kycAddressLine">
                      <img
                        src={`https://flagcdn.com/w40/${countryCode.toLowerCase()}.png`}
                        alt=""
                        className="kycRoundFlag"
                        style={{ marginRight: 10, marginBottom: 3 }}
                      />
                      <span>
                        {[street, city].filter(Boolean).join(", ")}
                        {[street, city].filter(Boolean).length && countryName
                          ? ", "
                          : ""}
                      </span>

                      {countryName ? (
                        <span className="kycCountryInline">
                          <span>{countryName}</span>
                        </span>
                      ) : null}
                    </div>
                  ) : (
                    <div className="kycInfoViewText">—</div>
                  )}
                </div>
              </div> */}
            </div>
          </div>

          <div className="col-12">
            {/* CONTACT: EMAIL / PHONE / WEBSITE */}
            <div className="kycViewTile">
              <div className="row g-3">
                <div className="col-4">
                  <div className="kycInfoItem">
                    <div className="kycInfoIcon">
                      <img src={iconEmail} alt="" className="kycInfoIconImg" />
                    </div>
                    <div className="kycInfoContent">
                      <div className="kycInfoViewLabel">Email</div>
                      <div className="kycInfoViewText">
                        {customer.email || "—"}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-4">
                  <div className="kycInfoItem">
                    <div className="kycInfoIcon">
                      <img
                        src={iconPhoneCall}
                        alt=""
                        className="kycInfoIconImg"
                      />
                    </div>
                    <div className="kycInfoContent">
                      <div className="kycInfoViewLabel">Phone</div>
                      <div className="kycInfoViewText">
                        {customer.phone || "—"}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-4">
                  <div className="kycInfoItem">
                    <div className="kycInfoIcon">
                      <img
                        src={iconWebsite}
                        alt=""
                        className="kycInfoIconImg"
                      />
                    </div>
                    <div className="kycInfoContent">
                      <div className="kycInfoViewLabel">Website</div>
                      <div className="kycInfoViewText">
                        {customer.website || "—"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12">
            {/* BUSINESS ACTIVITY */}
            <div className="kycViewTile">
              <div className="kycInfoItem">
                <div className="kycInfoIcon">
                  <img
                    src={iconBusinessActivity}
                    alt=""
                    className="kycInfoIconImg"
                  />
                </div>

                <div className="kycInfoContent">
                  <div className="kycInfoViewLabel">Business activity</div>
                  <div className="kycInfoViewText kycFirstLetterCaps">
                    {customer.businessActivity || "—"}
                  </div>
                </div>
              </div>
            </div>
            {/* kycCard kycViewBlock */}
            {/* <div className="kycViewTile">
              <div className="kycInfoViewLabel">Business activity</div>
              <div className={"kycInfoViewText kycFirstLetterCaps "}>
                {customer.businessActivity || "—"}
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
